module.exports = __webpack_public_path__ + "static/img/jcyc1.0d25d82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/jcyc1.png
// module id = HrhU
// module chunks = 0